export default __webpack_public_path__ + "static/media/challenge.3b61e4c5.mp3";